import { useMemo } from "react";
import { PDFHorizontalTableRow } from "components/PDF/Table/HorizontalTable";
import { BalancoFinanceiroPdfResponse } from "core/features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";

export function useResumoBalancoFinanceiroTableRows() {
  return useMemo(() => {
    return [
      {
        title: "Saldo Anterior:",
        renderValue: (original) => formatMoney(original.totalSaldoAnterior),
      },
      {
        title: "Total de Receitas:",
        renderValue: (original) => formatMoney(original.totalReceita),
      },
      {
        title: "Total de Despesas:",
        renderValue: (original) => formatMoney(original.totalDespesa),
      },
      {
        title: "Saldo do Período:",
        renderValue: (original) => formatMoney(original.saldoPeriodo),
      },
    ] as PDFHorizontalTableRow<BalancoFinanceiroPdfResponse>[];
  }, []);
}
